import { TutorialStep } from "..";

export const MakeDatasetModalSteps: TutorialStep[] = [
  {
    target: "#make-dataset-modal",
    content: `사용자가 리뷰한 이미지들을 기반으로 데이터셋을 생성할 수 있습니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#review-ng-list",
    content: `NG리스트는 review에서 NG로 판정된 이미지들을 모아놓은 리스트입니다. \n NG리스트를 통해 NG로 판정된 이미지들을 확인하고, 필요에 따라 재검토를 진행할 수 있습니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#make-dataset-ok-count",
    content: `NG로 review하지않은 모든 이미지들은 자동으로 OK 이미지로 분류되어 데이터셋에 포함됩니다. \n OK이미지들 수량을 조절할 수 있습니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#apply-make-dataset-btn",
    content: `Apply 버튼을 클릭하여 새로운 데이터셋을 생성해봅시다.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    nextTrigger: "#expand-collapse-dataset-btn",
    disableOverlayClose: true,
  },
  {
    target: "#expand-collapse-dataset-btn",
    content: `생성된 데이터셋은 프로젝트 페이지로 이동하여 확인 가능합니다.\n클릭하여 데이터셋 리스트를 확인하세요`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#dataset-card-grid",
    content: `이제 검사현황 단계의 튜토리얼을 완료합니다!`,
    spotlightClicks: false,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
];
